<template>
    <section>
        <div class="row">
            <div class="col-md-6">
                <h5><i class="fa fa-file-pdf-o"></i> Arquivos</h5>
                <table class="table table-sm table-hover table-condensed">
                    <thead>
                        <tr>
                            <th>Arquivo</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(file, f) in request.arquivos" :key="`file${f}`">
                            <td>{{file.name}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-md-6">
                <h5><i class="fa fa-users"></i> Signatários</h5>
                <table class="table table-sm table-hover table-condensed">
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>E-mail</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(assinatura, a) in request.signatarios" :key="`assinatura${a}`">
                            <td>{{assinatura.assinatura_nome}}</td>
                            <td>{{assinatura.assinatura_email}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        props: {
            request: {
                arquivos: [],
                signatarios: []
            }
        }
    }
</script>